export const LOGIN_URL = '/admin/login?front'
